'use client';

import { c as _c } from "react/compiler-runtime";
import { FeatherMessageSquare } from '@subframe/core';
import type { ConfigMensagemApuracao } from '../types';
import { formatarMoedaBR, formatarPrecoPorMensagem } from '../utils/apuracaoFormatters';
interface ApuracaoBlocoMensagemProps {
  config: ConfigMensagemApuracao;
}
export function ApuracaoBlocoMensagem(t0) {
  const $ = _c(29);
  const {
    config
  } = t0;
  let t1;
  if ($[0] !== config.mensagensIncluidas || $[1] !== config.mensagensUsadas) {
    t1 = config.mensagensIncluidas > 0 ? Math.round(config.mensagensUsadas / config.mensagensIncluidas * 100) : 0;
    $[0] = config.mensagensIncluidas;
    $[1] = config.mensagensUsadas;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const percentualUso = t1;
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="flex items-center gap-3"><div className="bg-brand-50 flex h-10 w-10 items-center justify-center rounded-lg"><FeatherMessageSquare className="text-brand-600 h-5 w-5" /></div><div><h3 className="text-body-bold font-body-bold text-default-font">Franquia de mensagens</h3><p className="text-caption font-caption text-subtext-color">Medida e cobrada separadamente da franquia de disparos</p></div></div>;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <p className="text-caption font-caption text-subtext-color">Mensagens incluídas</p>;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== config.mensagensIncluidas || $[6] !== config.mensagensUsadas) {
    t4 = <p className="text-body-bold font-body-bold text-default-font mt-1">{config.mensagensUsadas} / {config.mensagensIncluidas}</p>;
    $[5] = config.mensagensIncluidas;
    $[6] = config.mensagensUsadas;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== percentualUso) {
    t5 = <p className="text-caption font-caption text-subtext-color mt-0.5">{percentualUso}% usadas</p>;
    $[8] = percentualUso;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t4 || $[11] !== t5) {
    t6 = <div className="rounded-[12px] bg-neutral-50 p-4">{t3}{t4}{t5}</div>;
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <p className="text-caption font-caption text-subtext-color">Excedente</p>;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  const t8 = config.mensagensExcedentes;
  let t9;
  if ($[14] !== config.valorMensagemExcedente) {
    t9 = formatarPrecoPorMensagem(config.valorMensagemExcedente);
    $[14] = config.valorMensagemExcedente;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== config.mensagensExcedentes || $[17] !== t9) {
    t10 = <p className="text-body-bold font-body-bold text-default-font mt-1">{t8} × {t9}</p>;
    $[16] = config.mensagensExcedentes;
    $[17] = t9;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== config.valorExcedenteTotal) {
    t11 = formatarMoedaBR(config.valorExcedenteTotal);
    $[19] = config.valorExcedenteTotal;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] !== t11) {
    t12 = <p className="text-warning-700 text-caption font-caption mt-0.5">= {t11}</p>;
    $[21] = t11;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  let t13;
  if ($[23] !== t10 || $[24] !== t12) {
    t13 = <div className="rounded-[12px] bg-neutral-50 p-4">{t7}{t10}{t12}</div>;
    $[23] = t10;
    $[24] = t12;
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  let t14;
  if ($[26] !== t13 || $[27] !== t6) {
    t14 = <div className="bg-default-background flex flex-col gap-4 rounded-[16px] border border-solid border-neutral-200 p-6">{t2}<div className="grid grid-cols-1 gap-3 md:grid-cols-2">{t6}{t13}</div></div>;
    $[26] = t13;
    $[27] = t6;
    $[28] = t14;
  } else {
    t14 = $[28];
  }
  return t14;
}